import { useMediaQuery } from '@mui/material';

const useSmall = props => {
  const isSm = useMediaQuery(theme => theme?.breakpoints?.down('md'));
  return isSm;
};

export default useSmall;
